import { Container } from "@think-internet/ui-components";
import styled from "styled-components";

export const StyledReasons = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px 0 50px 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    padding: 0px 0 50px 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Headline = styled.div`
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: 32px;
  text-align: center;
  font-family: bold;
  width: 100%;
  line-height: 32px;
`;
export const PointWrapper = styled.div`
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 50px 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    flex-direction: column;
  }
`;

export const CTA = styled.a`
  background-color: ${({ theme }) => theme.color.background.red};
  color: ${({ theme }) => theme.color.font.secondary};
  padding: 7.5px 25px;
  margin: 50px 0 75px 0;
  display: inline-block;
  text-decoration: none;
`;
